import { useTranslation } from 'react-i18next'
import './SiteFooter.css'

const SUPPORT_EMAIL = 'support@colozoo.de'

const SiteFooter = () => {
  const { t } = useTranslation('home')
  const year = new Date().getFullYear()
  const mailto = `mailto:${SUPPORT_EMAIL}`

  return (
    <footer className="site-footer">
      <nav className="site-footer-nav" aria-label="Footer">
        <a href="https://colozoo.de/" target="_blank" rel="noopener noreferrer">{t('siteFooter.site')}</a>
        <span className="site-footer-sep" aria-hidden="true">•</span>
        <a href="/legal-notice/" target="_blank" rel="noopener noreferrer">{t('siteFooter.legal')}</a>
        <span className="site-footer-sep" aria-hidden="true">•</span>
        <a href="/privacy-policy/" target="_blank" rel="noopener noreferrer">{t('siteFooter.privacy')}</a>
        <span className="site-footer-sep" aria-hidden="true">•</span>
        <a href={mailto}>{t('siteFooter.help')}</a>
      </nav>
      <p className="site-footer-copy">© {year} Colozoo</p>
    </footer>
  )
}

export default SiteFooter
